// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Util$SmartcutsMacros = require("../../../../bs-utils/src/Util.bs.js");
var Selector$SmartcutsMacros = require("../../Selector.bs.js");
var DOM__Element$SmartcutsMacros = require("../../DOM__Element.bs.js");
var DOM__Attributes$SmartcutsMacros = require("../../DOM__Attributes.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "text",
                Decco.optionToJson(Decco.stringToJson, v.text)
              ],
              [
                "value",
                Decco.optionToJson(Decco.stringToJson, v.value)
              ],
              [
                "id",
                Decco.optionToJson(Decco.stringToJson, v.id)
              ],
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var value = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */0) {
      var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
      if (id.TAG === /* Ok */0) {
        var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
        if (selector.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    text: text._0,
                    value: value._0,
                    id: id._0,
                    selector: selector._0
                  }
                };
        }
        var e = selector._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".selector" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = id._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".id" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = value._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".value" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify(opt) {
  return JSON.stringify(t_encode(opt));
}

function valueAndTextGet(opt) {
  var text = opt.text;
  if (text !== undefined) {
    var value = opt.value;
    if (value !== undefined) {
      return [
              value,
              text
            ];
    } else {
      return [
              text,
              text
            ];
    }
  }
  var value$1 = opt.value;
  if (value$1 !== undefined) {
    return [
            value$1,
            value$1
          ];
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: opt.text and opt.value are both None");
  }
}

function valueGet(opt) {
  return opt.value;
}

function fromDomElement(element) {
  var attributes = DOM__Attributes$SmartcutsMacros.ofDomElement(element);
  var value = attributes.value;
  var value$1 = value !== undefined && value !== "" ? value : undefined;
  var match = element.tagName;
  switch (match) {
    case "INPUT" :
        var match$1 = attributes.type_;
        if (match$1 === undefined) {
          return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected DOM element from extract opt from, tagName=" + match);
        }
        if (match$1 !== "radio") {
          return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected DOM element from extract opt from, tagName=" + match);
        }
        var id = DOM__Element$SmartcutsMacros.idGet(element);
        var element$1 = document.querySelector("label[for=\"" + id + "\"]");
        var textInMatchingLabel = !(element$1 == null) ? DOM__Element$SmartcutsMacros.innerTextGet(element$1) : undefined;
        var match$2 = DOM__Element$SmartcutsMacros.innerTextGet(element);
        var text = textInMatchingLabel !== undefined ? textInMatchingLabel : (
            match$2 !== undefined ? match$2 : undefined
          );
        return {
                text: text,
                value: value$1,
                id: id,
                selector: Selector$SmartcutsMacros.forDomElement(element)
              };
    case "OPTION" :
        return {
                text: DOM__Element$SmartcutsMacros.innerTextGet(element),
                value: value$1,
                id: DOM__Element$SmartcutsMacros.idGet(element),
                selector: Selector$SmartcutsMacros.forDomElement(element)
              };
    default:
      return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected DOM element from extract opt from, tagName=" + match);
  }
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.valueAndTextGet = valueAndTextGet;
exports.valueGet = valueGet;
exports.fromDomElement = fromDomElement;
/* Util-SmartcutsMacros Not a pure module */
